module.exports = __webpack_public_path__ + "static/img/zwtp.8e86f1a3.png";